export const BOPISErrors = {
    invalidZipCodeMes: 'Please enter a valid ZIP code.',
    noAvailability:
        'Sorry, no availability at stores within 50 miles. Please enter a new ZIP code.',
    noResults: "Sorry! We can't find any stores within 50 miles of your search.",
    noResultsForCovid19:
        'Sorry, no availability at stores within 50 miles. Please enter a new ZIP code.',
    prePopulateError: 'Error while prepopulating stores',
    somethingWentWrong: 'Sorry, unable to find stores.',
    storesResultsZeroProducts:
        'Sorry! These items are not available at a store within 50 miles of your search.',
};

export const isGalleryURL = '/g/';

export const noSearchResult = {
    findAStore: 'Find a store.',
    noProductsFound: 'Sorry, no products were found matching:',
    searchTips: 'SEARCH TIPS',
    suggestionList: [
        {
            id: 'suggestion-1',
            text: 'Double check your spelling for typos.',
        },
        {
            id: 'suggestion-2',
            text: 'Use general term(s) or fewer keywords.',
        },
        {
            id: 'suggestion-3',
            text: 'Try searching for an item that is less specific and refine results.',
        },
        {
            id: 'suggestion-4',
            text: 'If you are looking for a specific terms from a printed ad.',
        },
        {
            id: 'suggestion-5',
            text: 'Enter the search term or web id as shown.',
        },
    ],
    suggestionWithStoreLink: 'Some product available in store may not be available online.',
    tryNewKeyword: 'Try a new keyword',
};

export const prevNoResultsMessage =
    'The previous results are shown because your last filters produced 0 results.';

export const source = 'rrplacementtype=';
export const url = 'url';
export const allProductsCategory = 'cat1007450013';

/**
 * Constructor facet configuration — mirrors the Java search-service backend config.
 *
 * searchableFiltersMap: facet names that should show a search box when option count > threshold
 * facetTypes: facet name → type mapping (default is 'checkbox')
 */
export const CONSTRUCTOR_FACET_CONFIG = {
    searchableFiltersMap: {
        brand: 13,
        size_range: 13,
        size: 13,
        item_type: 13,
        product_type: 13,
        occasion: 13,
        bed_size: 13,
        sleeve_length: 13,
        features: 13,
        waist: 13,
        dress_length: 13,
        fit: 13,
        stone: 13,
        childrens_sizes: 13,
        age_group: 13,
    },
    facetTypes: {
        color: 'color',
        s1_price_range: 'prange',
        s1_discount_range: 'prange',
        average_rating: 'avgrating',
        top_construction: 'checkboxImage',
        stone: 'image',
        stone_color: 'image',
        stone_cut: 'image',
        warmth_factor: 'checkboxImage',
    },
    defaultFacetType: 'checkbox',
};

/**
 * Default list of system/non-facet URL params that should NOT be sent as
 * filters to Constructor.io search API.
 *
 * Can be extended/reduced at runtime via preferences config:
 *   preferences.constructorIO.common.ignoreFilterParams = { add: [], remove: [] }
 */
export const CONSTRUCTOR_IGNORE_FILTER_PARAMS = [
    'ppisensemble',
    'cmJCP_T',
    'cmJCP_C',
    'marketing_tiles',
    'utm_medium',
    'cid',
    'utm_source',
    'utm_campaign',
    'utm_content',
    'cjevent',
    'cjdata',
    'debug',
    'mboxDisable',
    'adobe_mc',
    'cm_re',
    'contentDate',
    'usr_seg',
    'UsrSeg',
    'storeIds',
    'id',
    'searchTerm',
    'store_availability',
    'page',
    'mkt_tiles',
    'mktTiles',
    'boostIds',
    'activeFacetId',
    'productGridView',
    'mode',
    'sort',
    'searchType',
    'predSearchTerm',
    'redirectTerm',
    '_br_uid_2',
    'previewDate',
    'item_status',
    'channel',
    'responseType',
    'pageType',
    'Dr',
    'Ntt',
    'enableQueryProfile',
    'oneRecId',
    'selectedLotID',
    'selectedSKUId',
    'regionId',
    'disableNER',
    'disableESP',
    'disableAutoscope',
    'N',
    'ltrQueryEnabled',
    'disableLTR',
    'extractAdditionalFields',
    'incfacet',
    'hierarchyFacet',
    'excfval',
    'scrollTo',
    'predictiveDetail',
    'term',
    'nValue',
    'numProducts',
    'recentPP',
    'atgDevId',
    'addmsg',
    'removeColorFilter',
    'userzoneid',
    'geolocstoreid',
    'geolocstoreiddebug',
    'contentdate',
    'pagetype',
    'pageid',
    'version_cd',
    'cm_lm',
    'mi_u',
    'fCap',
    'targetqa',
    'TARGETQA',
    'targetQA',
    'utm_adgroupid',
    'utm_device',
    'utm_keyword',
    'utm_matchtype',
    'sfmc_sub',
    'gclid',
    'gclsrc',
    'afsrc',
    'fbclid',
    'gbraid',
    'degp_ladder_id',
    'degp_segment_id',
    'msclkid',
    'wbraids',
    'view_all',
    'Userzoneid',
    'geoZip',
    'geoLocStoreId',
    'atgdevid',
    'dpAkamaiOverride',
    'gad_source',
    'gad_campaignid',
    'utm_term',
    'utm_id',
    'clickid',
];
